import { useHistory } from '@react-router';
import { useTranslation } from '@shared/core';
import { ButtonV2 } from '@withjoy/joykit';
import React from 'react';

type BackButtonProps = {
  eventHandle: string;
};

export const BackButton = (props: BackButtonProps) => {
  const { eventHandle } = props;
  const history = useHistory();
  const { tq } = useTranslation('collaboration');

  const handleGoBack = () => {
    history.push(`/${eventHandle}`);
  };

  return (
    <ButtonV2
      variant="ghost"
      intent="neutral"
      width="fit-content"
      shape="rounded"
      onClick={handleGoBack}
    >{tq`Go back to event`}</ButtonV2>
  );
};
